module.exports = __webpack_public_path__ + "static/media/Library_7.bfe2012c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_7.png
// module id = 1294
// module chunks = 3